export const EXAMINATION_FROM = '2026-05-25';
export const EXAMINATION_TO = '2026-08-25';

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export function formatReleaseDate(isoDate: string): string {
  const [year, month, day] = isoDate.split('-').map(Number);
  return `${day} ${MONTHS[month - 1]} ${year}`;
}

export function criticalChangesEmptyText(from: string, to: string): string {
  const start = formatReleaseDate(from);
  const end = formatReleaseDate(to);
  return `No critical changes that affect customer processing were issued from ${start} to ${end}.`;
}
